const translations = {
    connectionError: 'Connection Error',
    fetchFailed: 'Failed to Load Prescription',
    saveFailed: 'Save Failed'
};

export default translations;
